export const DEFAULT_BASE_COLOR_HEX = '#111111';
export const DEFAULT_SHADE_COLOR_HEX = '#f8f1e4';
export const DEFAULT_BASE_COLOR_ID = 'black';
export const DEFAULT_SHADE_COLOR_ID = 'ivory';
export const PRODUCT_NAME_PREFIX = 'Kalpavriksha';
